import { render, staticRenderFns } from "./SideMenuLink.vue?vue&type=template&id=b60b3fae&scoped=true"
import script from "./SideMenuLink.vue?vue&type=script&lang=ts"
export * from "./SideMenuLink.vue?vue&type=script&lang=ts"
import style0 from "./SideMenuLink.vue?vue&type=style&index=0&id=b60b3fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60b3fae",
  null
  
)

export default component.exports